import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { List } from 'yoso';
import { AuthLink } from '~/components/Auth/Link/AuthLink';
import { BlankErrorBoundary } from '~/components/Error/Blank/BlankErrorBoundary';
import { ChallengeBoostQuickMenuItem } from '~/components/Quick/Menu/Challenge/Boost/ChallengeBoostQuickMenuItem';
import { CheckInQuickMenuItem } from '~/components/Quick/Menu/CheckIn/CheckInQuickMenuItem';
import { DonQuickMenuItem } from '~/components/Quick/Menu/Don/DonQuickMenuItem';
import { EvolveQuickMenuItem } from '~/components/Quick/Menu/Evolve/EvolveQuickMenuItem';
import { LevelUpQuickMenuItem } from '~/components/Quick/Menu/Level/LevelUpQuickMenuItem';
import { MissionQuickMenuItem } from '~/components/Quick/Menu/Mission/MissionQuickMenuItem';
import { NoticeQuickMenuItem } from '~/components/Quick/Menu/Notice/NoticeQuickMenuItem';
import { ResellQuickMenuItem } from '~/components/Quick/Menu/Resell/ResellQuickMenu';
import styles from './QuickMenu.module.scss';

export interface QuickMenuProps {
  className?: string;
}

export const QuickMenu = ({ className }: QuickMenuProps) => (
  <List className={classNames(styles.root, className)} data-event-category="quickmenu">
    <BlankErrorBoundary>
      <li>
        <Link to="?modal=checkIn" data-event="click" data-event-target="quickmenu_checkin_home">
          <CheckInQuickMenuItem />
        </Link>
      </li>
    </BlankErrorBoundary>
    <BlankErrorBoundary>
      <li>
        <AuthLink
          to="?modal=challengeGuide"
          data-event="click"
          data-event-target="quickmenu_boost_home">
          <ChallengeBoostQuickMenuItem />
        </AuthLink>
      </li>
    </BlankErrorBoundary>
    <BlankErrorBoundary>
      <li className={styles.desktopOnly}>
        <AuthLink to="/membership/don/history" data-event="click" data-event-target="quickmenu_don">
          <DonQuickMenuItem />
        </AuthLink>
      </li>
    </BlankErrorBoundary>
    <BlankErrorBoundary>
      <li>
        <Link
          to="/membership/mission"
          data-event="click"
          data-event-target="quickmenu_mission_home">
          <MissionQuickMenuItem />
        </Link>
      </li>
    </BlankErrorBoundary>
    <BlankErrorBoundary>
      <li className={styles.desktopOnly}>
        <Link
          to="/membership/item/friend/levelup"
          data-event="click"
          data-event-target="quickmenu_evolve_home">
          <EvolveQuickMenuItem />
        </Link>
      </li>
    </BlankErrorBoundary>
    <li className={styles.desktopOnly}>
      <a
        href={`${import.meta.env.VITE_CITIZEN_STORE_URL}/marketplace`}
        data-event="click"
        data-event-target="quickmenu_resell_home">
        <ResellQuickMenuItem />
      </a>
    </li>
    <BlankErrorBoundary>
      <li>
        <Link
          to="/support/notice?category=notice"
          data-event="click"
          data-event-target="quickmenu_notice_home">
          <NoticeQuickMenuItem />
        </Link>
      </li>
    </BlankErrorBoundary>
    <BlankErrorBoundary>
      <li>
        <Link
          to="/membership/item/citizen/levelup"
          data-event="click"
          data-event-target="quickmenu_levelup_home">
          <LevelUpQuickMenuItem />
        </Link>
      </li>
    </BlankErrorBoundary>
  </List>
);
